import { ReactNode } from "react";

/**
 * Mobile-only sticky action bar for detail pages, where the bottom tab bar is
 * intentionally hidden. It sits at the safe bottom so the primary CTA is
 * always reachable. Hidden on lg+ (desktop keeps its sticky side action card).
 * Pages using this should add `pb-24 lg:pb-6` to clear the bar.
 */
export function MobileActionBar({ children }: { children: ReactNode }) {
  return (
    <div className="mobile-action-bar lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-line px-3 py-2.5 flex items-center gap-2 shadow-[0_-4px_16px_rgba(16,32,60,0.08)]">
      {children}
    </div>
  );
}
